webpackJsonp([0],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRIGGER_DRAWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_DRAWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_ONLINE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _TRIGGER_DRAWER$UPDAT;

var TRIGGER_DRAWER = 'TRIGGER_DRAWER';
var UPDATE_DRAWER = 'UPDATE_DRAWER';
var SET_CLIENT_ID = 'SET_CLIENT_ID';
var UPDATE_ONLINE = 'UPDATE_ONLINE';

/* harmony default export */ __webpack_exports__["e"] = (_TRIGGER_DRAWER$UPDAT = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TRIGGER_DRAWER$UPDAT, TRIGGER_DRAWER, function (state) {
  state.drawer = !state.drawer;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TRIGGER_DRAWER$UPDAT, UPDATE_DRAWER, function (state, value) {
  state.drawer = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TRIGGER_DRAWER$UPDAT, SET_CLIENT_ID, function (state, value) {
  state.clientID = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TRIGGER_DRAWER$UPDAT, UPDATE_ONLINE, function (state, value) {
  state.online = value;
}), _TRIGGER_DRAWER$UPDAT);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins__ = __webpack_require__(73);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["e" /* default */],
  plugins: __WEBPACK_IMPORTED_MODULE_4__plugins__["a" /* default */]
}));

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutations__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ga__ = __webpack_require__(74);









Object(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.errorHandler = function (err) {
  // eslint-disable-next-line no-console
  console.error(err);
  /* globals ga */
  ga('send', 'exception', {
    exDescription: err.message,
    exFatal: false
  });
};

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App_vue__["a" /* default */]);
  }
});

window.addEventListener('online', function () {
  __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_6__store_mutations__["d" /* UPDATE_ONLINE */], navigator.onLine);
});

window.addEventListener('offline', function () {
  __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_6__store_mutations__["d" /* UPDATE_ONLINE */], navigator.onLine);
});

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd4fc38e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(69);
function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var normalizeComponent = __webpack_require__(1)
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd4fc38e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Toolbar: function Toolbar() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 51));
    },
    Drawer: function Drawer() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 59));
    },
    FooterSocial: function FooterSocial() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 63));
    },
    Hashtag: function Hashtag() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 66));
    }
  },
  data: function data() {
    return {
      width: window.innerWidth,
      links: [{ link: { name: 'home' }, display: 'Home' }, { link: { name: 'sponsor' }, display: 'Sponsor' }, { link: { name: 'timetable' }, display: 'Timetable' }, { link: { name: 'organizer' }, display: 'Organizer' }, { link: { name: 'venue' }, display: 'Venue' }, { link: { name: 'coc' }, display: 'Code of Conduct' }]
    };
  },

  methods: {
    resizeHandler: function resizeHandler() {
      this.width = window.innerWidth;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isMobile: function isMobile() {
      return this.width < 1024;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    route: function route(state) {
      return state.route.name;
    }
  })),
  mounted: function mounted() {
    window.addEventListener('resize', this.resizeHandler, { passive: false });
  }
});

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f1c9908_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Component_vue__ = __webpack_require__(58);
function injectStyle (ssrContext) {
  __webpack_require__(52)
}
var normalizeComponent = __webpack_require__(1)
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f1c9908"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f1c9908_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Component_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutations__ = __webpack_require__(0);




var eventbrite = 'https://sitcon-x-hk-2017.eventbrite.com/?aff=website&utm_source=website&utm_medium=website&utm_campaign=topbar&utm_content=register';

/* global window */

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isMobile: Boolean,
    drawer: Boolean,
    links: Array
  },
  data: function data() {
    return {
      card: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    toolbarClass: function toolbarClass() {
      if (!this.card) return '';
      return ['scroll-card', 'elevation-2'];
    },
    registerLink: function registerLink() {
      if (this.clientID && this.clientID.length > 0) {
        return eventbrite + '&_eboga=' + this.clientID;
      }
      return eventbrite;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['clientID'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    checkShowCard: function checkShowCard() {
      this.card = document.body.scrollTop > 100;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])({
    triggerDrawer: __WEBPACK_IMPORTED_MODULE_2__store_mutations__["b" /* TRIGGER_DRAWER */]
  })),
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('scroll', function () {
      return _this.checkShowCard();
    }, { passive: true });
  }
});

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.toolbarClass,attrs:{"id":"toolbar"}},[_c('nav',[(_vm.isMobile)?_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.triggerDrawer ($event)}}},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("menu")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title hidden-md-and-up"},[_c('router-link',{attrs:{"to":{name: 'home'},"data-role":"brand"}},[_vm._v("SITCON x HK 2017")])],1),_vm._v(" "),(!_vm.isMobile)?[_c('div',{staticClass:"content"},_vm._l((_vm.links),function(nav){return _c('router-link',{key:nav.display,attrs:{"to":nav.link}},[_vm._v("\n          "+_vm._s(nav.display)+"\n        ")])})),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('a',{staticClass:"register",attrs:{"target":"_blank","href":_vm.registerLink}},[_vm._v("Register")])]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24cf65e2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__ = __webpack_require__(62);
function injectStyle (ssrContext) {
  __webpack_require__(60)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24cf65e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24cf65e2_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutations__ = __webpack_require__(0);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var eventbrite = 'https://sitcon-x-hk-2017.eventbrite.com/?aff=website&utm_source=website&utm_medium=website&utm_campaign=drawer&utm_content=register';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['links'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    drawer: {
      get: function get() {
        return this.drawerState;
      },
      set: function set(val) {
        this.updateDrawer(val);
      }
    },
    registerLink: function registerLink() {
      if (this.clientID && this.clientID.length > 0) {
        return eventbrite + '&_eboga=' + this.clientID;
      }

      return eventbrite;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    drawerState: 'drawer',
    clientID: 'clientID'
  })),
  data: function data() {
    return { display: true };
  },
  mounted: function mounted() {
    this.display = true;
  },

  methods: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])({
    updateDrawer: __WEBPACK_IMPORTED_MODULE_2__store_mutations__["c" /* UPDATE_DRAWER */]
  })
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"temporary":"","light":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.links),function(nav){return _c('v-list-tile',{key:nav.display,staticClass:"drawer-tile",attrs:{"to":nav.link}},[_c('v-list-tile-content',[_vm._v("\n        "+_vm._s(nav.display)+"\n      ")])],1)}),_vm._v(" "),_c('v-list-tile',{staticClass:"ticket",attrs:{"tag":"a","target":"_blank","href":_vm.registerLink}},[_c('v-list-tile-content',[_vm._v("\n        Get Ticket\n      ")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6032bd8c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(65);
function injectStyle (ssrContext) {
  __webpack_require__(64)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6032bd8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6032bd8c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-3 mb-5",attrs:{"flat":"","light":""}},[_c('v-card-actions',{staticClass:"justify-center align-center"},[_c('v-btn',{staticClass:"mr-0 ml-0",attrs:{"icon":"","href":"https://www.facebook.com/SITCONxHK/","target":"_blank","tag":"a"}},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("fa-facebook-official")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mr-0 ml-0",attrs:{"icon":"","href":"mailto:contact@hk.sitcon.org","tag":"a"}},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("email")])],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"primary--text"},[_c('a',{attrs:{"rel":"license","target":"_blank","href":"http://creativecommons.org/licenses/by-sa/3.0/hk/"}},[_c('img',{attrs:{"alt":"Creative Commons Licence","src":"https://licensebuttons.net/l/by-sa/3.0/hk/88x31.png"}})]),_vm._v(" "),_c('br'),_vm._v("\n    This work is licensed under a CC BY-SA 3.0 Hong Kong License.\n    "),_c('wbr'),_vm._v("\n    Logos and trademarks belong to their respective owners.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34292eaa_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Hashtag_vue__ = __webpack_require__(68);
function injectStyle (ssrContext) {
  __webpack_require__(67)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34292eaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34292eaa_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Hashtag_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"primary--text",attrs:{"id":"hashtag"}},[_c('span',[_vm._v("#SITCONxHK")]),_vm._v(" "),_c('span',[_vm._v("#SITCONxHK2017")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:_vm.route},[(_vm.isMobile)?_c('drawer',{attrs:{"links":_vm.links}}):_vm._e(),_vm._v(" "),_c('toolbar',{attrs:{"isMobile":_vm.isMobile,"links":_vm.links}}),_vm._v(" "),_c('main',[(_vm.route != 'home')?_c('v-container',{attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade-transition"}},[_c('router-view')],1)],1):_c('transition',{attrs:{"name":"fade-transition"}},[_c('router-view')],1)],1),_vm._v(" "),_c('footer-social'),_vm._v(" "),_c('hashtag')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(71);



/* global ga */

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/!/:path',
    redirect: function redirect(to) {
      return '/' + to.params.path;
    }
  }, {
    path: '/',
    name: 'home',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 77));
    }
  }, {
    path: '/coc',
    name: 'coc',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 78));
    }
  }, {
    path: '/organizer',
    name: 'organizer',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 79));
    }
  }, {
    path: '/venue',
    name: 'venue',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 80));
    }
  }, {
    path: '/cfp',
    name: 'cfp',
    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 81));
    }
  }, {
    path: '/sponsor',
    name: 'sponsor',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 82));
    }
  }, {
    path: '/topic/the-geek',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 83));
    }
  }, {
    path: '/topic/culture-differences',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 84));
    }
  }, {
    path: '/topic/blockchain',
    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 85));
    }
  }, {
    path: '/topic/goby',
    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 86));
    }
  }, {
    path: '/topic/react-native',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 87));
    }
  }, {
    path: '/topic/electronic',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 88));
    }
  }, {
    path: '/topic/jupyter',
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 89));
    }
  }, {
    path: '/topic/media',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 90));
    }
  }, {
    path: '/topic/ecosystem',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 91));
    }
  }, {
    path: '/topic/ds',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 92));
    }
  }, {
    path: '/timetable',
    name: 'timetable',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 93));
    }
  }, {
    path: '/topic/SITCON-TW',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 94));
    }
  }, {
    path: '/topic/workshop',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 95));
    }
  }]
});

router.afterEach(function (to) {
  ga('set', 'page', '/2017' + to.path);
  ga('send', 'pageview');
  window.scrollTo(0, 0);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 71 */,
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  drawer: false,
  clientID: '',
  online: navigator.onLine
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__(0);


/* globals ga */

function drawerTracking(store) {
  store.subscribe(function (_ref, state) {
    var type = _ref.type;

    if ([__WEBPACK_IMPORTED_MODULE_0__mutations__["b" /* TRIGGER_DRAWER */], __WEBPACK_IMPORTED_MODULE_0__mutations__["c" /* UPDATE_DRAWER */]].indexOf(type) !== -1) {
      ga('send', 'event', 'Drawer', 'Change', state.drawer ? 'Open' : 'Close');
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = ([drawerTracking]);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutations__ = __webpack_require__(0);



var trackingID = 'UA-74628515-1';

var _window = window,
    ga = _window.ga;


ga('create', trackingID, 'auto');

function getClient() {
  var trackers = ga.getAll();
  if (!trackers.length) {
    ga(getClient);
  } else {
    trackers.some(function (tracker) {
      if (tracker.get('trackingId') === trackingID) {
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_1__store_mutations__["a" /* SET_CLIENT_ID */], tracker.get('clientId'));
        return true;
      }
      return false;
    });
  }
}
ga(getClient);

/***/ })
],[18]);


// WEBPACK FOOTER //
// app.fb4720945554d14b9bdb.js